import translations from './en-US.json';

export type TranslationKey = keyof typeof translations;
export type Translations = Record<TranslationKey, string>;

export const EN_DEFAULT: Translations = translations;
